$(document).ready(function () {
    $('.lang-current').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).parents('.lang-container').toggleClass('active');
    });

    $(document).on('click', function (event) {
        var $trigger = $('.lang-current');

        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $trigger.parents('.lang-container').removeClass('active');
        }
    });
});


$(document).ready(() => {
    // Gestion de l'ouverture/fermeture du menu déroulant
    const dropdown = $('.dropdown_languages');
    const arrow = $('#arrow-languages');

    $('.current-language-item').click((e) => {
        e.preventDefault();
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
        dropdown.toggleClass('hidden');
        arrow.toggleClass('rotate');
        dropdown.attr('aria-hidden', function (_, attr) {
            return attr === 'true' ? 'false' : 'true';
        });

        // Focus sur le premier élément lors de l'ouverture
        if (!dropdown.hasClass('hidden')) {
            $('.dropdown_languages a:first').focus();
        }
    });

    // Navigation avec les flèches haut/bas et fermeture avec Échap
    $(document).on('keydown', function (e) {
        if (!dropdown.hasClass('hidden')) {
            const focusableItems = $('.dropdown_languages a'); // Sélectionne les éléments navigables
            const currentIndex = focusableItems.index(document.activeElement);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                // Passe à l'élément suivant ou revient au début
                const nextIndex = (currentIndex + 1) % focusableItems.length;
                focusableItems.eq(nextIndex).focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                // Passe à l'élément précédent ou revient à la fin
                const prevIndex = (currentIndex - 1 + focusableItems.length) % focusableItems.length;
                focusableItems.eq(prevIndex).focus();
            } else if (e.key === 'Escape') {
                // Ferme le menu avec Échap
                dropdown.addClass('hidden');
                arrow.removeClass('rotate');
                dropdown.attr('aria-hidden', 'true');
                $('.current-language-item').focus();
            }
        }
    });
});